module.exports = __webpack_public_path__ + "71ec9c5b71503de720df47f1442ace29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideshow/2.jpg
// module id = 285
// module chunks = 0